import update from 'react-addons-update';
const iState = {
    Type: 1,
    Msg: ""
}

const ShowAlert = (state = iState, action) => {

    switch (action.type) {

        case 'UpdateAlert':
            return update(state, {
                Type: { $set: action.payload.Type },
                Msg: { $set: action.payload.Msg },
            });

        default:
            return state;

    }
}

export default ShowAlert;